import { render, staticRenderFns } from "./orderAdd.vue?vue&type=template&id=fb38ff9c&"
import script from "./orderAdd.vue?vue&type=script&lang=js&"
export * from "./orderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports